import { useForceRender } from '@codeleap/common'
import { useEffect } from 'react'
import { ReactPlayerProps } from 'react-player/lazy'

type PlayerComponent = ((props: ReactPlayerProps) => JSX.Element) & {
  canEnablePIP: (url: string) => boolean
  canPlay: (url: string) => boolean
}

let Player: PlayerComponent = (() => {
  return null
}) as unknown as PlayerComponent

export const useReactPlayer = () => {
  const forceRender = useForceRender()

  useEffect(() => {
    import('react-player/lazy').then(module => {
      Player = module.default as unknown as PlayerComponent
      forceRender()
    })
  }, [])

  return Player
}
